// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItemModal-cls1_P_T","cls2":"CreateSocialItemModal-cls2_Q1r CreateSocialItemModal-cls1_P_T"};